import { render, staticRenderFns } from "./control_ball.vue?vue&type=template&id=0f75d7c2&scoped=true&"
import script from "./control_ball.vue?vue&type=script&lang=js&"
export * from "./control_ball.vue?vue&type=script&lang=js&"
import style0 from "./control_ball.vue?vue&type=style&index=0&id=0f75d7c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f75d7c2",
  null
  
)

export default component.exports